export default __webpack_public_path__ + "static/verso-scheda-tecnica-dc780f294125fdeb81a4093dd210b65a.pdf";